module.exports = __webpack_public_path__ + "static/media/zera_putting_triangle.b7aa077e.gif";